import FileSaver from 'file-saver';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export const isDarkMode = () => window.matchMedia("(prefers-color-scheme: dark)").matches;

export const saveTextFile = async (text, filename, mimeType = 'text/plain;charset=utf-8') => {
  if (Capacitor.isNativePlatform()) {
    const {uri} = await Filesystem.writeFile({
      path: filename,
      data: text,
      directory: Directory.Cache,
      encoding: 'utf8',
    });
    await Share.share({url: uri, title: filename});
  } else {
    const blob = new Blob([text], {type: mimeType});
    FileSaver.saveAs(blob, filename);
  }
};
